import * as React from 'react';

import { Loader } from 'semantic-ui-react';

import { localeData } from '../../locales/data';
import { addModifiers } from '../../shared/helpers';
import { AlphasTagsPagination } from '../Alphas/AlphaListTags/AlphasTagsPagination';
import { Card } from '../Card';
import { TabsAggregationProps } from '../Competitions/CompetitionsMenu';
import { Container } from '../Container';
import { HOCMenu } from '../Menu/Menu';

import { MessagesList } from './MessagesList';
import { FooterComponent, OptionsComponent, Title } from './MessagesMenu';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

interface MessagesMainProps {
  data: any;
  type: 'announcements' | 'notifications';
  tabs: any;
  handleChangeTab: (type: 'announcements' | 'notifications') => void;
  typeAggregate: 'unread' | 'all';
  aggregations: TabsAggregationProps;
  handleChangeAggregation: (type: string) => void;
  handleMarkAsReadAll: () => void;
  handleMarkAsRead: (e: any) => void;
  isFetchingAnnouncement: boolean;
  isFetchingNotification: boolean;
  changePrevPage: () => void;
  changeNextPage: () => void;
  getPaginationNumbers: () => any[];
  page: number;
  changePage: (val: number) => void;
  pages: number;
}

const WrappedMessagesMenu = HOCMenu(Title, OptionsComponent, null, FooterComponent);

const MessagesMain = ({
  data,
  type,
  tabs,
  handleChangeTab,
  typeAggregate,
  aggregations,
  handleChangeAggregation,
  handleMarkAsReadAll,
  handleMarkAsRead,
  isFetchingAnnouncement,
  isFetchingNotification,
  changePrevPage,
  changeNextPage,
  getPaginationNumbers,
  page,
  changePage,
  pages,
}: MessagesMainProps) => {
  const Pagination = AlphasTagsPagination(null);

  const isThisTypeFetching = type === 'announcements' ? isFetchingAnnouncement : isFetchingNotification;

  return (
    <Container>
      <div className="messages">
        <WrappedMessagesMenu
          type={type}
          menuType=""
          tabs={tabs}
          handleChangeTab={handleChangeTab}
          hasFooter={true}
          typeAggregate={typeAggregate}
          aggregations={aggregations}
          handleChangeAggregation={handleChangeAggregation}
          handleMarkAsReadAll={handleMarkAsReadAll}
        />
        <div className={addModifiers('loader', isThisTypeFetching ? [] : ['hide'])}>
          <Loader active={isThisTypeFetching} inline="centered" size="massive" />
        </div>
        <div className={addModifiers('box-visibility', isThisTypeFetching ? ['hide'] : [])}>
          {data && data.size > 0 ? (
            <MessagesList data={data} isFetching={isThisTypeFetching} handleMarkAsRead={handleMarkAsRead} />
          ) : (
            <Card hasHeader={false}>
              <div className="messages__no-results">
                <FormattedMessageHelper tagName="span" id="messages.noResults" defaultMessage={localeData.en['messages.noResults']} />
              </div>
            </Card>
          )}
        </div>
        {data && data.size > 0 && (
          <div className={addModifiers('box-visibility', isThisTypeFetching ? ['hide'] : [])}>
            <Card hasHeader={false} modifiers={['message-pagination']}>
              <Pagination
                changePrevPage={changePrevPage}
                changeNextPage={changeNextPage}
                getPaginationNumbers={getPaginationNumbers}
                page={page}
                changePage={changePage}
                pages={pages}
              />
            </Card>
          </div>
        )}
      </div>
    </Container>
  );
};

export default MessagesMain;
